module.exports = __webpack_public_path__ + "static/SivaPrasadRdy-0c4f1e55f8ef8cee372a6e02b410cbeb.jpg";